import './menu.css';
import { useMenu } from "../../context/MenuContext";
import { MenuSection } from '../MenuSection/MenuSection';

export const Menu = () => {
    //HOOKS
    const { menu } = useMenu();

    return (
        <>
            <div className='menu_container'> 
                {
                    menu === null ? <h2>Loading...</h2> : ""
                }
                
                {
                    menu && menu.sections && menu.sections.map((section) => {
                        return (
                            <MenuSection 
                                section={section}
                                key={'menu_section' + section.id}
                            />
                        );
                    })
                }
            </div>
        </>
    );
}